'use client'

import {useCallback, useEffect, useState} from 'react'
import {setConsent} from '@/lib/analytics/posthog'

const CONSENT_STORAGE_KEY = 'analytics_consent'

/**
 * Hook to manage user consent for analytics tracking
 * @returns Object with consent state and functions to update it
 */
export function useAnalyticsConsent() {
  // const [consentGiven, setConsentGiven] = useState<boolean | null>(null)
  // const [consentShown, setConsentShown] = useState(false)
  const [consentGiven, setConsentGiven] = useState<boolean | null>(true)
  const [consentShown, setConsentShown] = useState(true)

  // By default now assume the consent is given
  // Load consent state from local storage on mount
  // useEffect(() => {
  //   // Only run in browser
  //   if (typeof window === 'undefined') return
  //
  //   try {
  //     // Check if consent has been previously stored
  //     const storedConsent = localStorage.getItem(CONSENT_STORAGE_KEY)
  //
  //     if (storedConsent !== null) {
  //       const parsedConsent = storedConsent === 'true'
  //       setConsentGiven(parsedConsent)
  //       setConsentShown(true)
  //     } else {
  //       // If no stored consent, check if PostHog has a consent state
  //       const posthogConsent = hasConsent()
  //       if (posthogConsent) {
  //         setConsentGiven(true)
  //         setConsentShown(true)
  //         localStorage.setItem(CONSENT_STORAGE_KEY, 'true')
  //       } else {
  //         // No stored consent and no PostHog consent, need to show banner
  //         setConsentGiven(null)
  //         setConsentShown(false)
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error loading analytics consent state:', error)
  //     // Default to no consent if there's an error
  //     setConsentGiven(false)
  //   }
  // }, [])

  useEffect(() => {
    if (typeof window) {
      setConsent(true)
    }
  }, [])

  // Function to give consent
  const giveConsent = useCallback(() => {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, 'true')
      setConsent(true)
      setConsentGiven(true)
      setConsentShown(true)
    } catch (error) {
      console.error('Error saving analytics consent state:', error)
    }
  }, [])

  // Function to deny consent
  const denyConsent = useCallback(() => {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, 'false')
      setConsent(false)
      setConsentGiven(false)
      setConsentShown(true)
    } catch (error) {
      console.error('Error saving analytics consent state:', error)
    }
  }, [])

  // Function to reset consent (for testing or user request)
  const resetConsent = useCallback(() => {
    try {
      localStorage.removeItem(CONSENT_STORAGE_KEY)
      setConsent(false) // Default to no tracking when consent is reset
      setConsentGiven(null)
      setConsentShown(false)
    } catch (error) {
      console.error('Error resetting analytics consent state:', error)
    }
  }, [])

  return {
    consentGiven,
    consentShown,
    giveConsent,
    denyConsent,
    resetConsent,
  }
}